// extracted by mini-css-extract-plugin
export default {"table":"TableWrapper_table__MA6mr"};